import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FacilityCard = ({ facility, onClick }) => {
  return (
    <div 
      className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all cursor-pointer"
      onClick={onClick}
    >
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg font-semibold text-foreground">{facility?.name}</h3>
            {facility?.emergency && (
              <span className="px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 text-xs font-medium rounded">
                24/7
              </span>
            )}
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-1">
            <Icon name="MapPin" size={14} />
            <span>{facility?.country}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Building2" size={14} />
            <span>{facility?.type} Facility</span>
          </div>
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className="flex items-center gap-1">
            <Icon name="Star" size={14} className="fill-yellow-400 text-yellow-400" />
            <span className="text-sm font-medium">{facility?.rating}</span>
          </div>
          {facility?.medicalTourism && (
            <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 text-xs font-medium rounded">
              Medical Tourism
            </span>
          )}
        </div>
      </div>
      <div className="border-t border-border pt-4 mb-4">
        <div className="flex flex-wrap gap-2 mb-3">
          {facility?.modalities?.slice(0, 4)?.map(modality => (
            <span
              key={modality}
              className="px-2 py-1 bg-accent/10 text-accent text-xs font-medium rounded"
            >
              {modality}
            </span>
          ))}
          {facility?.modalities?.length > 4 && (
            <span className="px-2 py-1 bg-muted text-muted-foreground text-xs font-medium rounded">
              +{facility?.modalities?.length - 4} more
            </span>
          )}
        </div>

        <div className="space-y-2 text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Icon name="Clock" size={14} />
            <span>{facility?.operatingHours}</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Icon name="Calendar" size={14} />
            <span>Wait time: {facility?.waitTime}</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Icon name="Phone" size={14} />
            <span>{facility?.phone}</span>
          </div>
          {facility?.whatsapp && (
            <div className="flex items-center gap-2 text-green-600 dark:text-green-400">
              <Icon name="MessageCircle" size={14} />
              <span>WhatsApp: {facility?.whatsapp}</span>
            </div>
          )}
        </div>
      </div>
      <div className="border-t border-border pt-4">
        <p className="text-xs text-muted-foreground mb-2">Accepts:</p>
        <div className="flex flex-wrap gap-1 mb-3">
          {facility?.insurance?.slice(0, 3)?.map(insurance => (
            <span
              key={insurance}
              className="px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 text-xs rounded"
            >
              {insurance}
            </span>
          ))}
          {facility?.insurance?.length > 3 && (
            <span className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded">
              +{facility?.insurance?.length - 3}
            </span>
          )}
        </div>

        <Button
          onClick={(e) => {
            e?.stopPropagation();
            onClick();
          }}
          className="w-full bg-accent hover:bg-accent/90 text-accent-foreground"
        >
          View Details
        </Button>
      </div>
    </div>
  );
};

export default FacilityCard;